import { createSlice } from "@reduxjs/toolkit";

function restoreSession() { try { return JSON.parse(localStorage.getItem("formula_session") || "null"); } catch { return null; } }
const restored = restoreSession();
const authSlice = createSlice({
  name: "auth",
  initialState: { user: restored?.user || null, accessToken: restored?.accessToken || null, ready: false },
  reducers: {
    sessionSet(state, action) { state.user = action.payload.user; state.accessToken = action.payload.accessToken; localStorage.setItem("formula_session", JSON.stringify(action.payload)); },
    accessTokenSet(state, action) { state.accessToken = action.payload; localStorage.setItem("formula_session", JSON.stringify({ user: state.user, accessToken: action.payload })); },
    sessionCleared(state) { state.user = null; state.accessToken = null; localStorage.removeItem("formula_session"); },
    authReady(state) { state.ready = true; },
  },
});
export const { sessionSet, accessTokenSet, sessionCleared, authReady } = authSlice.actions;
export default authSlice.reducer;
